import React from 'react';
import './NotFound.scss';
import image404 from '../../assets/images/notfound/404.png';
import { MdArrowBack } from 'react-icons/md';
import { Link } from 'react-router-dom';

function NotFound() {
    return (
        <div className='notfound'>
            <div className='veiculosecia__content d-flex flex-column align-items-center justify-content-center h-100'>
                <img src={image404} alt='404' />
                <p className='mt-3 mb-3'>Página não encontrada!</p>
                <Link to='/'><MdArrowBack />VOLTAR</Link>
            </div>
        </div>
    )
}

export default NotFound;
